var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tiptap-vuetify',{attrs:{"extensions":_vm.extensions},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }